var map = {
	"./icon-app-store.svg": "9e1f",
	"./icon-google-play.svg": "2108",
	"./it_extensiondegarantia.png": "1e62",
	"./it_seguromovil.png": "bf52",
	"./it_seguromultidispositivo.png": "841c7",
	"./it_seguropatinete.png": "7ac2",
	"./it_seguroportatil.png": "d24e",
	"./menu-barras.png": "2107",
	"./mx_extensiondegarantia.png": "b3d3",
	"./mx_seguromovil.png": "63b1",
	"./mx_seguromovil.svg": "d2a9",
	"./mx_seguromultidispositivo.png": "f3bf",
	"./mx_seguromultidispositivo.svg": "02d1",
	"./mx_seguropatinete.png": "0c5c",
	"./mx_seguroportatil.png": "8834",
	"./mx_seguroportatil.svg": "0436",
	"./pt_seguromovil.png": "da41",
	"./pt_seguromultidispositivo.png": "004d",
	"./pt_seguropatinete.png": "888e",
	"./pt_seguroportatil.png": "2f14"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9988";